import type { ComponentProps } from 'react';

import { cn } from '../lib/cn';

export const inputClassName = cn(
  // D1 §5: 입력은 버튼과 같은 8px.
  'border-line bg-surface text-ink px-row py-snug w-full rounded-lg border text-sm',
  'placeholder:text-ink-faint',
  'ease-flow duration-fast transition-colors',
  'hover:border-line-strong',
  'focus:border-line-accent focus:outline-none',
  'disabled:bg-surface-sunken disabled:cursor-not-allowed disabled:opacity-60',
  'aria-invalid:border-danger',
);

export function Input({ className, ...props }: ComponentProps<'input'>) {
  return <input className={cn(inputClassName, 'h-10', className)} {...props} />;
}

export function Textarea({ className, ...props }: ComponentProps<'textarea'>) {
  // 내용만큼 자란다(field-sizing). 손잡이는 숨긴다(D150) — field-sizing이 없는 브라우저에서만 세로 손잡이를 남긴다.
  return (
    <textarea
      className={cn(
        inputClassName,
        'field-sizing-content min-h-24 resize-none supports-[not(field-sizing:content)]:resize-y',
        className,
      )}
      {...props}
    />
  );
}
